// extracted by mini-css-extract-plugin
export default {"status":"StatusLabel_status__KawHB","bounceIcon":"StatusLabel_bounceIcon__HXk77","status_close":"StatusLabel_status_close__vK-0l"};